import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'collapse'];

  static values = {
    onlyOne: Boolean,
  };

  toggle(e) {
    e.preventDefault();

    let item;
    this.itemTargets.forEach((testItem) => {
      if (testItem.contains(e.currentTarget)) {
        item = testItem;
      }
    });

    if (!item) {
      return;
    }

    let collapseNode;
    this.collapseTargets.forEach((testTarget) => {
      if (item.contains(testTarget)) {
        collapseNode = testTarget;
      }
    });

    if (item.classList.contains('active')) {
      item.classList.remove('active');
      $(collapseNode).slideUp('fast');
    } else {
      item.classList.add('active');
      $(collapseNode).slideDown('fast');

      if (this.onlyOneValue) {
        this.itemTargets.forEach((testItem) => {
          if (testItem !== item) {
            testItem.classList.remove('active');
          }
        });

        this.collapseTargets.forEach((testTarget) => {
          if (testTarget !== collapseNode) {
            $(testTarget).slideUp('fast');
          }
        });
      }
    }
  }
}
